








import {
  Component,
  Emit,
  Inject,
  Model,
  Prop,
  Provide,
  Vue,
  Watch
} from "vue-property-decorator";
import { State, Getter, Action, Mutation, namespace } from "vuex-class";
import * as types from "@/store/constants/types";
import VipOfferUtils from "@/utils/vipOfferUtils";

@Component({
  components: {
    // [Tabbar.name]: Tabbar,
  }
})
export default class VipNav extends Vue {
  @Prop({
    default: () => {
      return null;
    }
  })
  private offer?: any;

  @Action(types.ROUTER_PUSH)
  private routerPush: any;
  @Getter(types.GETTER_CAN_SHOW_VIP_NAV)
  private canShowVipNav: any;
  @Getter(types.GETTER_PRO_EXTRA_PERCENTAGE)
  private vipExtraPercentage: any;

  get showVipNav() {
    console.log(this.canShowVipNav(this.offer))
    return this.canShowVipNav(this.offer)
  }

  get autoVip() {
    return !VipOfferUtils.firstVipService().is_no_auto_renew
  }

  get boughtVip() {
    return VipOfferUtils.boughtVip()
  }

  get showText() {
    return this.boughtVip ? 'GET' : this.autoVip ? 'TRY FOR FREE' : 'GET'
  }

  private goVipCenter() {
    this.routerPush({
      name: "VipCenter",
      params: {
        routerTransition: "up",
        type: "multiple"
      },
      query: {
        type: "multiple",
        sildeIndex: 'slide2'
      }
    });
  }
}
